
import { defineComponent, onMounted } from "vue";
import Dropdown1 from "@/components/dropdown/Dropdown1.vue";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";

export default defineComponent({
  name: "kt-widget-5",
  props: {
    widgetClasses: String
  },
  components: {
    Dropdown1
  },
  setup() {
    onMounted(() => {
      MenuComponent.reinitialization();
    });
  }
});
